export const PRODUCT_COLORS = [
  "#1976d2",
  "#2e7d32",
  "#ed6c02",
  "#d32f2f",
  "#0288d1",
  "#6a1b9a",
  "#00838f",
  "#f9a825",
  "#5d4037",
  "#455a64",
  "#c2185b",
  "#512da8",
  "#00796b",
  "#ef6c00",
  "#1565c0",
];

export const TOTAL_STROKE = "#2e7d32";

export function getProductStroke(index, excludeStroke = TOTAL_STROKE) {
  const palette = PRODUCT_COLORS.filter(
    (color) => color.toLowerCase() !== excludeStroke?.toLowerCase()
  );
  const colors = palette.length > 0 ? palette : PRODUCT_COLORS;
  return colors[index % colors.length];
}
